import { InvoiceThird } from './invoice-third.model';

export class InvoiceOrganization {
  third?: InvoiceThird;
  jdeNumber: number;
  ean?: string;
  fiscalCompany?: number;
  region?: string;

  constructor(values= {}) {
    Object.assign(this, values);
    this.third = this.third ? new InvoiceThird(this.third) : new InvoiceThird();
  }
}
